<header *ngIf="!isLoggedIn()" class="w-full flex justify-between items-center px-6 py-3 bg-white border-b shadow-sm sticky top-0 z-40">
    <div class="flex items-center gap-2">
        <img src="../../assets/images/logo/O360.svg" alt="Organiza360" class="h-8" />
        <span class="font-semibold text-lg text-gray-800">Organiza360</span>
    </div>

    <button
        routerLink="/"
        class="text-sm font-medium text-blue-600 hover:underline"
    >
        Entrar / Criar conta
    </button>
</header>
<section *ngIf="!isLoggedIn()" class="text-center bg-blue-50 py-4 px-6 rounded-lg border border-blue-100 shadow-sm max-w-5xl mx-auto mt-6">
    <p class="text-sm md:text-base text-gray-800">
        <strong>Crie a sua conta gratuitamente</strong> e experimente a gestão de eventos por <strong>7 dias sem limitações</strong>. <br />
        Explore o catálogo e peça o seu orçamento sem compromisso.
    </p>
</section>

<div class="p-6 max-w-4xl mx-auto">
    <h1 class="text-3xl font-bold mb-8 text-center">Pedido de Orçamento</h1>

    <div class="grid md:grid-cols-2 gap-6">
        <!-- Resumo de produtos -->
        <div class="bg-white border border-gray-200 rounded-xl shadow p-6 flex flex-col justify-between h-full">
            <div>
                <h2 class="text-lg font-semibold mb-4">Resumo dos produtos</h2>
                <ul class="divide-y">
                    <li *ngFor="let item of quoteItems" class="py-3 flex items-center justify-between text-sm text-gray-800">
                        <div class="flex items-center gap-3">
                            <img
                                *ngIf="item.images?.[0]"
                                [src]="item.images[0]"
                                alt="{{ item.name }}"
                                class="w-10 h-10 object-cover rounded border"
                            />
                            <span>{{ item.name }}</span>
                        </div>
                        <span class="text-gray-500">x{{ item.quantity }}</span>
                    </li>
                </ul>
            </div>

            <div class="mt-6">
                <a
                    routerLink="/product-catalog"
                    class="inline-flex items-center text-sm text-blue-600 hover:underline"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
                    </svg>
                    Voltar para o catálogo
                </a>
            </div>
        </div>

        <!-- Formulário -->
        <div class="bg-white border border-gray-200 rounded-xl shadow p-6">
            <h2 class="text-lg font-semibold mb-4">Seus dados</h2>
            <form (ngSubmit)="submitQuote()" #quoteForm="ngForm" class="space-y-4">
                <div *ngIf="!isLoggedIn()" class="space-y-2">
                    <mat-form-field appearance="outline" class="w-full">
                        <mat-label>Nome</mat-label>
                        <input matInput type="text" name="name" [(ngModel)]="formData.name" required>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="w-full">
                        <mat-label>Email</mat-label>
                        <input matInput type="email" name="email" [(ngModel)]="formData.email" required>
                    </mat-form-field>
                </div>

                <mat-form-field appearance="outline" class="w-full">
                    <mat-label>Telefone</mat-label>
                    <input matInput type="tel" name="phone" [(ngModel)]="formData.phone" required>
                </mat-form-field>

                <mat-form-field appearance="outline" class="w-full">
                    <mat-label>Mensagem (opcional)</mat-label>
                    <textarea matInput name="message" rows="4" [(ngModel)]="formData.message"></textarea>
                </mat-form-field>

                <button
                    mat-raised-button
                    color="primary"
                    [disabled]="!quoteForm.form.valid || isSubmitting"
                    class="h-10 px-6 flex items-center justify-center w-full"
                    type="submit"
                >
                    <mat-progress-spinner
                        *ngIf="isSubmitting"
                        diameter="20"
                        mode="indeterminate"
                        color="accent"
                        class="mr-2"
                        strokeWidth="3"
                    ></mat-progress-spinner>

                    <mat-icon *ngIf="!isSubmitting" class="mr-2">send</mat-icon>
                    {{ isSubmitting ? 'A Enviar...' : 'Enviar Pedido' }}
                </button>

            </form>
        </div>
    </div>
</div>
